import React from "react";
import PT from "prop-types";
import { Link } from "@quintype/components";

import "./hamburger-menu-item.m.css";

const HamburgerMenuItem = ({ item, toggleHandler, menuStyle = "menu-link" }) => {
  if (item["item-type"] === "placeholder") {
    return <span styleName="menu-link">{item.title}</span>;
  } else if (item["item-type"] === "link") {
    return (
      <a
        styleName={menuStyle}
        onClick={toggleHandler}
        className={menuStyle}
        target="_blank"
        rel="noopener noreferrer"
        href={item.completeUrl || "/"}
      >
        {item.title}
      </a>
    );
  } else {
    return (
      <Link
        styleName={menuStyle}
        aria-label="menu-item"
        callback={toggleHandler}
        className={menuStyle}
        href={item.completeUrl || "/"}
      >
        {item.title}{/*item.children.length>0&&<i class="ri-arrow-right-s-fill"></i>*/}{/**this is used if needed for hamburger dropdown logo */}
      </Link>
    );
  }
};

HamburgerMenuItem.propTypes = {
  item: PT.object,
  showIcon: PT.bool
};

export { HamburgerMenuItem };
